const SelectedOutcomes = {
    title: 'Example JSON for selectedOutcomes parameter',
    initialDisplayedCode: `{
        "selectedOutcomes":[{
            "id": 1234,
            "odds": 1900,
            "startingPrice": true
        }, {
            "id": 45678,
            "odds": 2000
        }],
        "betErrorsIndexes":[1],
        "translations":{
            "startingPrice":"SP",
            "totalOddsNotAvailable":"N/A"
        }
    }`,
};

export default SelectedOutcomes;
